import React from "react";
import { useTranslation } from "react-i18next";
import { LanguageSelectTextInput } from "@sinch/components/application/LanguageSelectTextInput/LanguageSelectTextInput";
import type { AddRateComponentFormFields } from "@sinch/components/application/RateComponent/formSchema";
import { useMuiController } from "@sinch/components/index";
import { useFocusOnMount } from "@sinch/components/providers/AutofocusProvider/FocusProvider";

export const ComponentName = () => {
  const { t } = useTranslation();
  const { field: nameField } = useMuiController<AddRateComponentFormFields, "name">({
    name: "name",
    rules: { required: true },
  });
  const ref = useFocusOnMount(nameField.inputRef);

  return (
    <LanguageSelectTextInput
      {...nameField}
      inputProps={{ "data-cy": "ComponentForm-name-input" }}
      inputRef={ref}
      label={t("RateBuilder.addComponentName")}
      placeholder={t("enterPlaceholder", {
        inputName: (t("RateBuilder.addComponentName") as string).toLowerCase(),
      })}
      required
      value={nameField.value}
    />
  );
};
